// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vacancy-container {
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vacancy-dark-bg {
  background: #fff;
  min-height: 100vh;
  width: 100vw;
  padding-top: 0;
  padding-bottom: 0;
}

.vacancy-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
}

.vacancy-logo {
  width: auto;
  height: auto;
  margin: 2rem auto 1.5rem auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vacancy-logo img {
  max-width: 200px;
  max-height: 120px;
  object-fit: contain;
  width: auto !important; /* Override any inline width */
}
.vacancy-logo svg {
  color: #999;
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
}

.vacancy-preview-image {
  width: 100%;
  max-width: 700px;
  height: 260px;
  border-radius: 18px;
  margin-bottom: 2rem;
  overflow: hidden;
}
.vacancy-preview-image img.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Embla Carousel Styles */
.vacancy-carousel-container {
  position: relative;
  width: 100%;
  max-width: 700px;
  margin-bottom: 2rem;
}

.embla {
  overflow: hidden;
  border-radius: 18px;
}

.embla__container {
  display: flex;
  height: 260px;
}

.embla__slide {
  flex: 0 0 100%;
  min-width: 0;
  position: relative;
}
.embla__slide img.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.embla__prev,
.embla__next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}
.embla__prev:hover,
.embla__next:hover {
  background: rgba(255, 255, 255, 0.9);
}
.embla__prev svg,
.embla__next svg {
  color: #045438;
  font-size: 1.8rem;
}

.embla__prev {
  left: 16px;
}

.embla__next {
  right: 16px;
}

.vacancy-green-title {
  color: #045438 !important;
  font-weight: 700;
}

.vacancy-green-subtitle {
  color: #045438 !important;
  font-weight: 500;
  margin-bottom: 1rem;
}

.vacancy-cta-btn {
  background: #045438 !important;
  color: #fff !important;
  font-weight: 600;
  font-size: 1.1rem;
  border-radius: 24px;
  padding: 0.7rem 2.5rem;
  box-shadow: 0 2px 12px rgba(30, 185, 84, 0.15);
  margin-bottom: 1.5rem;
}

.vacancy-offer-section {
  background: #f5f7fa;
  border-radius: 18px;
  padding: 2rem 1.5rem;
  margin: 2rem 0 2rem 0;
  width: 100%;
  max-width: 700px;
}
.vacancy-offer-section ul {
  list-style: none;
  padding-left: 0.5rem;
}
.vacancy-offer-section li {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.vacancy-offer-section li .check-circle {
  background-color: #045438;
  border-radius: 50%;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.vacancy-offer-section li .check-circle svg {
  color: white;
  font-size: 1rem;
}

.vacancy-description {
  padding-top: 1.5rem;
  color: #333;
  width: 100%;
  max-width: 700px;
}
.vacancy-description .job-description-content {
  margin-top: 1rem;
}
.vacancy-description .job-description-content h1,
.vacancy-description .job-description-content h2,
.vacancy-description .job-description-content h3,
.vacancy-description .job-description-content h4,
.vacancy-description .job-description-content h5,
.vacancy-description .job-description-content h6 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #045438;
}
.vacancy-description .job-description-content ul,
.vacancy-description .job-description-content ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}
.vacancy-description .job-description-content p {
  margin-bottom: 1rem;
}

.vacancy-privacy-notice {
  background: #f5f7fa;
  border-radius: 18px;
  padding: 1.5rem;
  margin: 1rem 0 2rem 0;
  width: 100%;
  max-width: 700px;
}

.vacancy-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  text-align: center;
}

/* Application Form */
.vacancy-application-form {
  background: #f5f7fa;
  border-radius: 18px;
  padding: 2rem;
  margin: 2rem 0;
  width: 100%;
  max-width: 700px;
  animation: fadeIn 0.3s ease-in-out;
}
.vacancy-application-form form {
  margin-top: 1.5rem;
}
.vacancy-application-form .MuiTextField-root {
  margin-bottom: 0.5rem;
  background-color: #fff;
  border-radius: 8px;
}
.vacancy-application-form .MuiOutlinedInput-root {
  border-radius: 8px;
}
.vacancy-application-form .MuiInputLabel-root {
  color: #045438;
}
.vacancy-application-form .MuiOutlinedInput-notchedOutline {
  border-color: #e0e0e0;
}
.vacancy-application-form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #045438;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Success Message */
.vacancy-application-success {
  background: #d4edda;
  color: #155724;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin: 2rem 0;
  width: 100%;
  max-width: 700px;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}
.vacancy-application-success p {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Vacancy/style.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA,EAAA,8BAAA;AACJ;AAEE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAKA,0BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFJ;;AAMA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,gCAAA;AAHF;AAKE;;EACE,oCAAA;AAFJ;AAKE;;EACE,cAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,yBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8CAAA;EACA,qBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAHF;AAKE;EACE,gBAAA;EACA,oBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAJN;AAMM;EACE,YAAA;EACA,eAAA;AAJR;;AAUA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAPF;AAQE;EACE,gBAAA;AANJ;AAOI;;;;;;EAME,kBAAA;EACA,qBAAA;EACA,cAAA;AALN;AAOI;;EAEE,mBAAA;EACA,mBAAA;AALN;AAOI;EACE,mBAAA;AALN;;AAUA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAPF;;AAUA,qBAAA;AACA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;AAPF;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,qBAAA;AAXJ;AAcE;EACE,qBAAA;AAZJ;;AAgBA;EACE;IACE,UAAA;IACA,2BAAA;EAbF;EAeA;IACE,UAAA;IACA,wBAAA;EAbF;AACF;AAgBA,oBAAA;AACA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;AAdF;AAgBE;EACE,gBAAA;AAdJ","sourcesContent":[".vacancy-container {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.vacancy-dark-bg {\n  background: #fff;\n  min-height: 100vh;\n  width: 100vw;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.vacancy-centered {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: none;\n}\n\n.vacancy-logo {\n  width: auto;\n  height: auto;\n  margin: 2rem auto 1.5rem auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    max-width: 200px;\n    max-height: 120px;\n    object-fit: contain;\n    width: auto !important; /* Override any inline width */\n  }\n\n  svg {\n    color: #999;\n    background: #f5f5f5;\n    padding: 15px;\n    border-radius: 8px;\n  }\n}\n\n.vacancy-preview-image {\n  width: 100%;\n  max-width: 700px;\n  height: 260px;\n  border-radius: 18px;\n  margin-bottom: 2rem;\n  overflow: hidden;\n\n  img.preview-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n/* Embla Carousel Styles */\n.vacancy-carousel-container {\n  position: relative;\n  width: 100%;\n  max-width: 700px;\n  margin-bottom: 2rem;\n}\n\n.embla {\n  overflow: hidden;\n  border-radius: 18px;\n}\n\n.embla__container {\n  display: flex;\n  height: 260px;\n}\n\n.embla__slide {\n  flex: 0 0 100%;\n  min-width: 0;\n  position: relative;\n\n  img.preview-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.embla__prev,\n.embla__next {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.7);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: background 0.3s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.9);\n  }\n\n  svg {\n    color: #045438;\n    font-size: 1.8rem;\n  }\n}\n\n.embla__prev {\n  left: 16px;\n}\n\n.embla__next {\n  right: 16px;\n}\n\n.vacancy-green-title {\n  color: #045438 !important;\n  font-weight: 700;\n}\n\n.vacancy-green-subtitle {\n  color: #045438 !important;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.vacancy-cta-btn {\n  background: #045438 !important;\n  color: #fff !important;\n  font-weight: 600;\n  font-size: 1.1rem;\n  border-radius: 24px;\n  padding: 0.7rem 2.5rem;\n  box-shadow: 0 2px 12px rgba(30, 185, 84, 0.15);\n  margin-bottom: 1.5rem;\n}\n\n.vacancy-offer-section {\n  background: #f5f7fa;\n  border-radius: 18px;\n  padding: 2rem 1.5rem;\n  margin: 2rem 0 2rem 0;\n  width: 100%;\n  max-width: 700px;\n\n  ul {\n    list-style: none;\n    padding-left: 0.5rem;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n\n    .check-circle {\n      background-color: #045438;\n      border-radius: 50%;\n      min-width: 24px;\n      height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: 12px;\n\n      svg {\n        color: white;\n        font-size: 1rem;\n      }\n    }\n  }\n}\n\n.vacancy-description {\n  padding-top: 1.5rem;\n  color: #333;\n  width: 100%;\n  max-width: 700px;\n  .job-description-content {\n    margin-top: 1rem;\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin-top: 1.5rem;\n      margin-bottom: 0.5rem;\n      color: #045438;\n    }\n    ul,\n    ol {\n      margin-left: 1.5rem;\n      margin-bottom: 1rem;\n    }\n    p {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n.vacancy-privacy-notice {\n  background: #f5f7fa;\n  border-radius: 18px;\n  padding: 1.5rem;\n  margin: 1rem 0 2rem 0;\n  width: 100%;\n  max-width: 700px;\n}\n\n.vacancy-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  text-align: center;\n}\n\n/* Application Form */\n.vacancy-application-form {\n  background: #f5f7fa;\n  border-radius: 18px;\n  padding: 2rem;\n  margin: 2rem 0;\n  width: 100%;\n  max-width: 700px;\n  animation: fadeIn 0.3s ease-in-out;\n\n  form {\n    margin-top: 1.5rem;\n  }\n\n  .MuiTextField-root {\n    margin-bottom: 0.5rem;\n    background-color: #fff;\n    border-radius: 8px;\n  }\n\n  .MuiOutlinedInput-root {\n    border-radius: 8px;\n  }\n\n  .MuiInputLabel-root {\n    color: #045438;\n  }\n\n  .MuiOutlinedInput-notchedOutline {\n    border-color: #e0e0e0;\n  }\n\n  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: #045438;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Success Message */\n.vacancy-application-success {\n  background: #d4edda;\n  color: #155724;\n  border-radius: 8px;\n  padding: 1rem 1.5rem;\n  margin: 2rem 0;\n  width: 100%;\n  max-width: 700px;\n  text-align: center;\n  animation: fadeIn 0.3s ease-in-out;\n\n  p {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
